// ZigZag of MetaTrader 5 (ZigZag.mq5): TradingView's Zig Zag has other
// inputs (deviation in %, no backstep), PO has the MetaTrader ones.
// Marks use 0 for "none", as in MetaTrader (prices are positive).

const SEARCH = { ANY: 0, PEAK: 1, BOTTOM: -1 };

const windowExtreme = (bars, key, index, depth, pick) => {
  let extreme = bars[index][key];

  for (let position = index - 1; position > index - depth && position >= 0; position -= 1) {
    extreme = pick(extreme, bars[position][key]);
  }

  return extreme;
};

// First pass: candidate extremes of every bar (LowMapBuffer / HighMapBuffer)
const markExtremes = (bars, key, { depth, backstep, deviation }, isLow) => {
  const marks = new Float64Array(bars.length);
  const pick = isLow ? Math.min : Math.max;
  let lastExtreme = 0;

  for (let index = depth; index < bars.length; index += 1) {
    const price = bars[index][key];
    let extreme = windowExtreme(bars, key, index, depth, pick);

    if (extreme === lastExtreme) {
      extreme = 0;
    } else {
      lastExtreme = extreme;

      if ((isLow ? price - extreme : extreme - price) > deviation) {
        extreme = 0;
      } else {
        for (let back = 1; back <= backstep; back += 1) {
          const mark = marks[index - back];

          if (mark !== 0 && (isLow ? mark > extreme : mark < extreme)) marks[index - back] = 0;
        }
      }
    }

    marks[index] = price === extreme ? extreme : 0;
  }

  return marks;
};

/**
 * Pivots of the ZigZag: the price of a turning point at its bar, 0 elsewhere.
 *
 * @param {object[]} bars
 * @param {{ depth: number, backstep: number, deviation: number }} settings - deviation in price units
 * @returns {Float64Array}
 */
export const zigZagPivots = (bars, settings) => {
  const lows = markExtremes(bars, "low", settings, true);
  const highs = markExtremes(bars, "high", settings, false);
  const pivots = new Float64Array(bars.length);
  let search = SEARCH.ANY;
  let lastLow = 0;
  let lastHigh = 0;
  let lastLowIndex = -1;
  let lastHighIndex = -1;

  const setLow = (index, price) => {
    lastLow = price;
    lastLowIndex = index;
    pivots[index] = price;
  };
  const setHigh = (index, price) => {
    lastHigh = price;
    lastHighIndex = index;
    pivots[index] = price;
  };

  for (let index = settings.depth; index < bars.length; index += 1) {
    const low = lows[index];
    const high = highs[index];

    if (search === SEARCH.ANY && lastLow === 0 && lastHigh === 0) {
      if (high !== 0) {
        setHigh(index, bars[index].high);
        search = SEARCH.BOTTOM;
      }
      if (low !== 0) {
        setLow(index, bars[index].low);
        search = SEARCH.PEAK;
      }
    } else if (search === SEARCH.PEAK) {
      if (low !== 0 && low < lastLow && high === 0) {
        pivots[lastLowIndex] = 0;
        setLow(index, low);
      }
      if (high !== 0 && low === 0) {
        setHigh(index, high);
        search = SEARCH.BOTTOM;
      }
    } else if (search === SEARCH.BOTTOM) {
      if (high !== 0 && high > lastHigh && low === 0) {
        pivots[lastHighIndex] = 0;
        setHigh(index, high);
      }
      if (low !== 0 && high === 0) {
        setLow(index, low);
        search = SEARCH.PEAK;
      }
    }
  }

  return pivots;
};
